import React from 'react';
import { Folder, FolderGit2, Laptop, Link2, LayoutPanelLeft, Users } from 'lucide-react';
import { WORKSPACES, SCOPES } from './gitTargets';

const ICON = { linked: Folder, local: Laptop, folder: FolderGit2, unlinked: Link2 };
const iconOf = (t) => (t.kind === 'scope' ? (t.team ? Users : LayoutPanelLeft) : ICON[t.kind] || Folder);

/**
 * The Git page's picker (redesign 05.10.2026): one pill per workspace and per
 * projects / boards / documents scope, grouped; the pill shows the name, how
 * many changes wait and a dot for its state (green synced, amber waiting, red
 * failed, grey not connected). The selected one fills the detail card.
 */
export default function GitTargetPills({ targets, selectedId, onSelect }) {
  const groups = [WORKSPACES, SCOPES].map((g) => [g, targets.filter((t) => t.group === g)]).filter(([, list]) => list.length);
  return (
    <div className="git-groups" data-testid="git-targets">
      {groups.map(([group, list]) => (
        <div key={group} className="git-group" role="group" aria-label={group}>
          <h2 className="git-label">{group}</h2>
          <div className="git-pills">
            {list.map((t) => {
              const Icon = iconOf(t);
              const active = t.id === String(selectedId);
              return (
                <button
                  key={t.id}
                  type="button"
                  className={`git-pill${t.connected ? ' git-pill--on' : ''}${active ? ' git-pill--active' : ''}`}
                  aria-pressed={active}
                  data-git-target={t.id}
                  data-git-kind={t.kind}
                  data-git-repo={t.repo || undefined}
                  data-tone={t.tone}
                  onClick={() => onSelect(t.id)}
                >
                  <span className="git-pill-icon" aria-hidden>
                    <Icon size={11} />
                  </span>
                  <span className="git-pill-name">{t.name}</span>
                  {t.waiting > 0 && (
                    <span className="git-badge" aria-label={`${t.waiting} waiting`}>
                      {t.waiting}
                    </span>
                  )}
                  <span className={`git-dot git-dot--${t.tone}`} aria-hidden />
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
